module.exports = __webpack_public_path__ + "media/images/wines/tempranillo-roble/bottle-ac15ad5e4e4cc705bb64daa8f42f1f61.png";